import { render, staticRenderFns } from "./StoriesBlock.vue?vue&type=template&id=0e6a472c&scoped=true"
import script from "./StoriesBlock.vue?vue&type=script&lang=js"
export * from "./StoriesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6a472c",
  null
  
)

export default component.exports